import {
  OperationID,
  OperationBody,
  OperationDate,
  OperationFileAttachmentIDs,
  OperationState,
  OperationSubject,
  OperationType,
  OperationClientID,
  OperationCompleteDatetime,
  OperationFileAttachmentID,
  OperationTeamID
} from '../../../operationsTypes';

import { ConvertFileToDropzoneFile } from '../../../../../helpers/dropzone/DropzoneHelper/utils/convertFileToDropzoneFile/convertFileToDropzoneFile.types';

export interface UpdateOperationFormData {
  clientId: OperationClientID;
  subject: OperationSubject;
  body: OperationBody;
  date: OperationDate;
  completeDatetime?: OperationDate;
  operationType: OperationType;
  state: OperationState;
  fileAttachmentIds?: OperationFileAttachmentIDs;
  createCompanyRecord?: boolean;
}

export interface UpdateOperationFormOperation {
  id: OperationID;
  body: OperationBody;
  subject: OperationSubject;
  operationType: OperationType;
  state: OperationState;
  date: OperationDate;
  completeDatetime: OperationCompleteDatetime;
  fileAttachments: ({
    id: OperationFileAttachmentID;
  } & ConvertFileToDropzoneFile)[];
  client: {
    id: OperationClientID;
  };
  teamId?: OperationTeamID;
}

export interface UpdateOperationFormAccess {
  changeClientId?: boolean;
  changeOperationType?: boolean;
  changeSubject?: boolean;
  changeBody?: boolean;
  changeDate?: boolean;
  changeCompleteDatetime?: boolean;
  changeState?: boolean;
  changeFileAttachmentIds?: boolean;
  changeCreateCompanyRecordCheckbox?: boolean;
}

export const enum UpdateOperationFormFields {
  CREATE_COMPANY_RECORD = 'createCompanyRecord'
}
